const alternateKeys = {
    getAllVariants: () => ['variants'],
    getVariantsByComponentId: (componentId: string) => [
        'variants',
        componentId,
    ],
    getVariantsByMessageContentId: (messageContentId: string) => [
        'variants',
        messageContentId,
    ],
};

export default alternateKeys;
